/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Endpoint_Run_In_PlaygroundInputs */

const en_app_endpoint_run_in_playground = /** @type {(inputs: App_Endpoint_Run_In_PlaygroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run it for real in the Playground`)
};

const zh_hans1_app_endpoint_run_in_playground = /** @type {(inputs: App_Endpoint_Run_In_PlaygroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在“在线调试”中正式运行`)
};

const pt_br2_app_endpoint_run_in_playground = /** @type {(inputs: App_Endpoint_Run_In_PlaygroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Execute de verdade no Playground`)
};

const es_app_endpoint_run_in_playground = /** @type {(inputs: App_Endpoint_Run_In_PlaygroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejecútalo de verdad en el Playground`)
};

const fr_app_endpoint_run_in_playground = /** @type {(inputs: App_Endpoint_Run_In_PlaygroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancez-la pour de vrai dans le Playground`)
};

const de_app_endpoint_run_in_playground = /** @type {(inputs: App_Endpoint_Run_In_PlaygroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Playground richtig ausführen`)
};

const ru_app_endpoint_run_in_playground = /** @type {(inputs: App_Endpoint_Run_In_PlaygroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запустите по-настоящему в Playground`)
};

const it_app_endpoint_run_in_playground = /** @type {(inputs: App_Endpoint_Run_In_PlaygroundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eseguilo davvero nel Playground`)
};

/**
* | output |
* | --- |
* | "Run it for real in the Playground" |
*
* @param {App_Endpoint_Run_In_PlaygroundInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const app_endpoint_run_in_playground = /** @type {((inputs?: App_Endpoint_Run_In_PlaygroundInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Endpoint_Run_In_PlaygroundInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_app_endpoint_run_in_playground(inputs)
	if (locale === "pt-BR") return pt_br2_app_endpoint_run_in_playground(inputs)
	if (locale === "es") return es_app_endpoint_run_in_playground(inputs)
	if (locale === "fr") return fr_app_endpoint_run_in_playground(inputs)
	if (locale === "de") return de_app_endpoint_run_in_playground(inputs)
	if (locale === "ru") return ru_app_endpoint_run_in_playground(inputs)
	if (locale === "it") return it_app_endpoint_run_in_playground(inputs)
	return en_app_endpoint_run_in_playground(inputs)
});